import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  TextField, Button, Typography, Container, Box, Snackbar, Alert
} from '@mui/material';
import ReactMarkdown from 'react-markdown';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';
import { useNavigate } from 'react-router-dom'; // ✅ Added for redirection

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const styles = {
  inputBox: {
    marginBottom: '1rem',
    color: 'white',
  },
  responseBox: {
    backgroundColor: '#121212',
    padding: '1rem',
    borderRadius: '12px',
    color: 'white',
    marginTop: '1.5rem',
    whiteSpace: 'pre-wrap',
  },
  button: {
    marginTop: '1rem',
    backgroundColor: '#1E90FF',
    color: 'white',
  },
};

const Vidya = ({ userId, onLogout }) => {
  const [userMessage, setUserMessage] = useState('');
  const [llmReply, setLlmReply] = useState('');
  const [error, setError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate(); // ✅ Navigation hook

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!userId) {
      const tempId = localStorage.getItem('chat_user_id') || `user_${Date.now()}`;
      localStorage.setItem('chat_user_id', tempId);
    }
  }, [userId]);

  const sendMessage = async () => {
    if (!userMessage.trim() || loading) return;

    // ✅ Redirect if message matches trigger
    const triggers = [
      "show all sessions",
      "view sessions",
      "overall sessions",
      "view overall sessions"
    ];
    const lowerMessage = userMessage.toLowerCase();
    if (triggers.some(trigger => lowerMessage.includes(trigger))) {
      navigate("/overall-sessions");
      return;
    }

    setLoading(true);
    setError('');
    setLlmReply('');

    try {
      const response = await axios.post(`${API_URL}/api/chat/`, {
        message: userMessage,
        user_id: userId || localStorage.getItem('chat_user_id'),
      });

      setLlmReply(response.data.reply || 'No reply received.');
      setUserMessage('');
    } catch (err) {
      console.error(err);
      setError('Failed to connect to the AI server.');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div style={{ backgroundColor: '#000', minHeight: '100vh', paddingTop: '5rem' }}>
      <Header1 userId={userId} onLogout={onLogout} />
      <Container maxWidth="md">
        <Box
          sx={{
            padding: '2rem',
            borderRadius: '16px',
            backgroundColor: '#1a1a1a',
            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.4)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}
        >
          <Typography
            variant="h4"
            align="center"
            sx={{
              backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
              fontWeight: 'bold',
              letterSpacing: 3,
              mb: 4,
            }}
          >
            Ask Anything
          </Typography>

          <TextField
            label="Tell us what you want to learn"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={userMessage}
            onChange={(e) => setUserMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            sx={styles.inputBox}
            InputLabelProps={{ style: { color: 'white' } }}
            InputProps={{
              style: { color: 'white' },
            }}
            disabled={loading}
          />

          <Button
            variant="contained"
            fullWidth
            onClick={sendMessage}
            sx={styles.button}
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Submit'}
          </Button>

          {llmReply && (
            <Box sx={styles.responseBox}>
              <Typography variant="h6" gutterBottom>AI Response:</Typography>
              <ReactMarkdown>{llmReply}</ReactMarkdown>
            </Box>
          )}
        </Box>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={() => setOpenSnackbar(false)}
        >
          <Alert severity="error" onClose={() => setOpenSnackbar(false)}>
            {error}
          </Alert>
        </Snackbar>
      </Container>
      {/* <Footer2 /> */}
    </div>
  );
};

export default Vidya;
